const CodeTracking = {
  showTrackingPosition: function (valueToShow) {
    // return <div style={{ width: "500px" }}>Tracking word: {valueToShow}</div>;
  },

  showTrackingApi: function (apiNameToShow) {
    // return (
    //   <div style={{ width: "500px" }}>Tracking api url: {apiNameToShow}</div>
    // );
  },
};

export default CodeTracking;
